import React from 'react';
import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types';
import Breadcrumb from '../../breadcrumb/component.tsx';
import { createProjectSettingsUrl } from '../common/create-url';
import messages from './messages';
import type { ProjectSettingsBreadcrumbPropsWithIntl } from './types';

const ProjectSettingsBreadcrumb = ({
	children,
	projectKey,
	projectType,
	isSimplified = false,
	intl: { formatMessage },
}: ProjectSettingsBreadcrumbPropsWithIntl) =>
	projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
	(projectType === CORE_PROJECT ||
		projectType === SOFTWARE_PROJECT ||
		projectType === SERVICE_DESK_PROJECT) ? (
		<Breadcrumb
			breadcrumb={{
				href: createProjectSettingsUrl(projectKey, projectType, isSimplified),
				text: formatMessage(messages.projectSettingsTitle),
				type: 'projectSettings',
			}}
		>
			{children}
		</Breadcrumb>
	) : (
		children
	);

export default ProjectSettingsBreadcrumb;
